

<app-header-title>
  <span title>{{'worksystemsettings.EmployeeSystems'|translate}}</span>
</app-header-title>



<div class="faspinner" *ngIf="loading">
  <dx-load-indicator width="24px" height="24px" [visible]="true"></dx-load-indicator>
</div>

<div *ngIf="!loading">
  <!-- <app-back-page (backAction)="backToMainPage($event)"></app-back-page> -->
  <form (submit)="onFormSubmit($event)" style="padding: 0rem 3rem;">
    <dx-form>
      <dxi-item [colCount]="12" [colSpan]="12">
        <app-employee-system [form]="employeeSystemData"></app-employee-system>
      </dxi-item>
      <dxi-item itemType="button" horizontalAlignment="left" [buttonOptions]="buttonOptions">
      </dxi-item>
    </dx-form>
  </form>

</div>